import React from 'react'
import './Header.css'

export default () => {
    return (
        <header className={'Header'}>
            <h1>Image Grid</h1>
        </header>
    )
}

